__turbopack_context__.v({
  "changeText": "language-selector-module___8s1cq__changeText",
  "chevronDownIcon": "language-selector-module___8s1cq__chevronDownIcon",
  "closeIcon": "language-selector-module___8s1cq__closeIcon",
  "languageDropdown": "language-selector-module___8s1cq__languageDropdown",
  "languageLink": "language-selector-module___8s1cq__languageLink",
  "languageLinkNoButton": "language-selector-module___8s1cq__languageLinkNoButton",
  "languageSelector": "language-selector-module___8s1cq__languageSelector",
  "navItem": "language-selector-module___8s1cq__navItem",
  "navItemGroup": "language-selector-module___8s1cq__navItemGroup",
  "navLink": "language-selector-module___8s1cq__navLink",
  "selectYourLanguage": "language-selector-module___8s1cq__selectYourLanguage",
  "selectedLocale": "language-selector-module___8s1cq__selectedLocale",
  "title": "language-selector-module___8s1cq__title",
  "visible": "language-selector-module___8s1cq__visible",
  "worldIcon": "language-selector-module___8s1cq__worldIcon",
});
